// Resolves which backend the app talks to, so the same build works on every environment and
// nobody has to edit base_url when code moves between dev and prod.
//
// Order:
//   1. REACT_APP_BACKEND_URL at build/start time (e.g. in a git-ignored .env.local for a
//      developer's own port: REACT_APP_BACKEND_URL=http://localhost:4000/).
//   2. The hostname the app is served from (table below).
//   3. Unknown hostname: same-origin /backend/, with a console warning.
//
// Note: REACT_APP_API_BASE_URL is NOT the main backend; it is the eKYC service (EKYC_BASE_URL).

const BACKEND_BY_HOST = {
  localhost: "http://localhost:5643/",
  "127.0.0.1": "http://localhost:5643/",
  "dev.bennefin.com": "https://dev-api.bennefin.com/",
  "app.bennefin.com": "https://prod.bennefin.com/backend/",
};

const withTrailingSlash = (url) => (url.endsWith("/") ? url : url + "/");

const resolveBackendUrl = () => {
  const override = process.env.REACT_APP_BACKEND_URL;
  if (override) return withTrailingSlash(override.trim());

  const host = window.location.hostname;
  if (BACKEND_BY_HOST[host]) return BACKEND_BY_HOST[host];

  const fallback = `${window.location.origin}/backend/`;
  console.warn(`[environment] No backend configured for host "${host}"; using ${fallback}`);
  return fallback;
};

export const BACKEND_URL = resolveBackendUrl();

// eKYC service base (callers append "/risk/..." etc.), passed through unchanged. Set at build time.
export const EKYC_BASE_URL = process.env.REACT_APP_API_BASE_URL || "";
if (!EKYC_BASE_URL) {
  console.warn("[environment] REACT_APP_API_BASE_URL (eKYC service) is not set; eKYC screens will not work.");
}

export const IS_LOCALHOST = ["localhost", "127.0.0.1"].includes(window.location.hostname);
